<div class="card p-4 d-flex flex-column mt-2">
  <nz-skeleton [ngClass]="skeleton ? 'p-3':'p-0'" [nzLoading]="skeleton" [nzActive]="true" [nzParagraph]="false">
    <div class="py-1 title">
      Subscriptions
      <hr />
    </div>
  </nz-skeleton>
  <nz-card id="card-upgrade-subscription" class="col-12 col-lg-5 p-3 border rounded" nzHoverable>
    <nz-skeleton [ngClass]="skeleton ? 'p-3':'p-0'" [nzLoading]="skeleton" [nzActive]="true">
      <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start gap-3">
        <div class="d-flex flex-column">
          Current Package
          <div class="title mt-2 flex gap-2 items-center">
            <img [src]="iconLabelPackage[statusBillings.package_name?.toLowerCase() || 'starter']" alt="package"
              width="40px">
            <span class="text-capitalize">{{ statusBillings.package_name || "Starter" }}</span>
          </div>
        </div>
        <div class="flex flex-col justify-end items-start sm:items-center">
          <button id="btn-upgrade-subscription" [disabled]="isAutoSubscribe"
            [ngClass]="isAutoSubscribe ? 'btn-outline-secondary !bg-[#f5f5f5]' : 'btn-primary text-white'"
            class="btn !flex justify-center items-center h-6 w-full sm:w-[135px]" type="button"
            (click)="handleUpgrade()">
            <div class="flex justify-center items-center gap-2">
              <img [src]="isAutoSubscribe ? 'https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/arrow-up.svg' : 'https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/arrow-up.svg'" alt="upgrade"
                width="16px" [class.opacity-80]="isAutoSubscribe" />
              <span class="text-center text-sm">Upgrade</span>
            </div>
          </button>
          @if (statusBillings.package_name?.toLowerCase() === 'starter' || !statusBillings.package_name) {
          <span class="text-[10px] mt-1">Start from 149k/month</span>
          } @else {
          <div class="flex items-center gap-1 mt-1">
            <img src="https://storage.googleapis.com/komerce/assets/komerce-icon/Hitam/calendar-2.svg" alt="calendar-2"
              width="16px" class="opacity-50">
            <div class="flex flex-wrap gap-1">
              <span class="text-[10px] text-[#626262]">Valid Until :</span>
              <strong class="text-[10px]">{{
                (statusBillings.subscription_expired | date: 'dd MMMM yyyy') || '-'}}</strong>
            </div>
          </div>
          }
        </div>
      </div>
      <div [@collapseExpand]="activeDetail ? 'expanded' : 'collapsed'" class="mb-4">
        <div class="border-dash py-2 mt-4"></div>
        <div class="flex justify-between items-start gap-3">
          <div class="flex flex-col gap-1 w-2/3 sm:w-1/2">
            <span class="font-semibold">Auto Subscription</span>
            <span class="text-[12px] text-[#626262]">Automatically renews your package every month using your RajaOngkir
              balance.</span>
          </div>
          <nz-switch [ngModel]="isAutoSubscribe" (ngModelChange)="toggleAutoSubscribe($event)"
            [disabled]="currentMode !== 'production'"
            [ngbPopover]="currentMode !== 'production' ? popContentSubs : null" placement="top right"
            triggers="mouseenter:mouseleave"></nz-switch>
          <ng-template #popContentSubs>
            <div class="flex flex-col gap-1">
              <span class="font-semibold">Live Mode Required</span>
              <span class="text-[14px] text-[#626262]">Switch to Live Mode to unlock this feature.</span>
            </div>
          </ng-template>
        </div>
      </div>
      @if (statusBillings.package_name?.toLowerCase() !== 'starter' && statusBillings.package_name) {
      <div class="text-center detail-bg py-1" (click)="activeDetail = !activeDetail">
        Auto Subscription
        <i class="text-bold mx-1" [ngClass]="activeDetail ? 'k-arrow-up-2' : 'k-arrow-down-1'"></i>
      </div>
      } @else {
      <div class="w-full rounded-lg border-[#FBA63C] border-[1px] bg-[#FFF8E1] flex items-center gap-2 md:h-10 h-fit px-2">
        <img src="https://storage.googleapis.com/komerce/assets/svg/warning-Info-circle.svg" alt="warning"
          class="w-[24px]">
        <span class="text-[12px] text-[#AF6A13]">You are using the free package. Upgrade to get premium features.</span>
      </div>
      }
    </nz-skeleton>
  </nz-card>
  <div class="col-12 mt-5 overflow-x-auto">
    <nz-skeleton [ngClass]="skeleton ? 'p-3':'p-0'" [nzLoading]="skeleton" [nzActive]="true">
      <h6>Subscriptions History</h6>
      <cdk-virtual-scroll-viewport itemSize="20" class="scroll-viewport" (scrolledIndexChange)="onScroll()"
        style="height: 500px; width: 100%; min-width: 600px;">
        <nz-table #headerTable [nzData]="listOfData" [nzShowPagination]="false" class="mt-3" [nzLoading]="loading">
          <thead>
            <tr class="membership">
              @for (column of listOfColumns; track column) {
              <th>
                <div class="d-flex justify-content-between">
                  <span>
                    {{ column.name }}
                  </span>
                  <img *ngIf="column.name === 'Date'"
                    src="https://storage.googleapis.com/komerce/assets/icons/arrow-filter.svg" alt="arrow"
                    (click)="shortHistoryBillings()" />
                </div>
              </th>
              }
            </tr>
          </thead>
          <tbody>
            <ng-container *cdkVirtualFor="let data of listOfData">
              <tr>
                <td>
                  <span class="d-flex align-items-center justify-content-center" [ngClass]="styleStatus(data.status)">{{
                    handleStatus(data.status) }}</span>
                </td>
                <td>
                  {{ data.created_at | date : "dd MMMM yyyy" }}
                </td>
                <td>
                  {{ data.expired_date ? (data.expired_date | date : "dd MMMM yyyy") : "-" }}
                </td>
                <td class="flex flex-wrap gap-1">
                  <img [src]="iconPackage(data.package)" alt="package" /> •
                  {{ data.package_duration }}
                  <span *ngIf="data.package_duration > 1">Months</span>
                  <span *ngIf="data.package_duration === 1">Month</span>
                </td>
                <td *ngIf="data.amount !== 0">{{ data.amount | idr }}</td>
                <td *ngIf="data.amount === 0">Free</td>
                <td>
                  <span class="d-flex gap-2 text-blue" style="cursor: pointer;"
                    (click)="downloadInvoice(data.invoice_id)">
                    <img src="https://storage.googleapis.com/komerce/icon/receipt-blue.svg" alt="receipt">
                    Receipt</span>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </nz-table>
      </cdk-virtual-scroll-viewport>
    </nz-skeleton>
  </div>
</div>
